/**
 * @file   千年琴史 首页
 * @create macaiqi 2025/05/06
 * @update
 */
import React, { useEffect, useState } from 'react';

// import bg from '../../../assets/images/qnqsbg.jpg';
import Slider from 'react-slick';
import cls from 'classnames';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { queryAllChannel } from '../../../service';

import './index.scss';

export default function QNQS({ setShow }) {
  const [channeldata, setChanneldata] = useState([]);

  const NextArrow = ({ className, style, onClick }) => (
    <div className={cls(className)} onClick={onClick} style={style} />
  );
  const PrevArrow = ({ className, style, onClick }) => (
    <div className={cls(className)} onClick={onClick} style={style} />
  );
  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 7,
    slidesToScroll: 1,
    prevArrow: <PrevArrow className="arrow prevarrow" />,
    nextArrow: <NextArrow />,
  };
  useEffect(() => {
    queryAllChannel('QNQS').then(res => {
      setChanneldata(res?.records)
    })
  }, [])
  return (
    <div className="common-page qnqs-page">
      {/* <img src={bg} alt="" /> */}
      <div
        className="back"
        onClick={() => {
          setShow();
        }}></div>
      <div className="box  animate__animated  animate__slideInRight animate__slow">
        <Slider {...settings}>
          {channeldata.map((item, index) => {
            return (
              <div
                className={cls("item", `${item.channelNo}-item`)}
                key={index}
                onClick={() => {
                  setShow(`qnqscontent-${item.channelNo}`);
                }}>
                <div className="title"></div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}
